<mat-drawer-container class="main-container">
  <mat-drawer class="side-menu" #drawer [mode]="'over'" [position]="'end'">
    <!-- NOTE Side Menu -->
    <mat-tree #tree [dataSource]="menuList()" [childrenAccessor]="childrenAccessor">
      <!-- NOTE Not have submenu -->
      <mat-tree-node class="side-menu-item" *matTreeNodeDef="let node" matTreeNodePadding>
        <!-- use a disabled button to provide padding for tree leaf -->
        <a (click)="handleClick(node); drawer.close()" (keyup.enter)="handleClick(node); drawer.close()" tabindex="0">
          {{ node.title }}
        </a>
      </mat-tree-node>
      <!-- NOTE Have submenu -->
      <mat-tree-node
        class="side-menu-item"
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        matTreeNodeToggle
        [cdkTreeNodeTypeaheadLabel]="node.name"
      >
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        {{ node.title }}
      </mat-tree-node>
    </mat-tree>
  </mat-drawer>
  <mat-drawer-content>
    <header>
      <!-- NOTE Logo -->
      <div class="logo">
        <img
          src="/assets/images/img-logo.png"
          alt="โลโก้แบรนด์"
          title="โลโก้แบรนด์"
          [routerLink]="['/']"
          class="logo-img"
          width="276"
          height="74"
          loading="eager"
        />
      </div>
      <!-- NOTE Nav Menu -->
      <nav class="nav-menu">
        @for (menu of menuList(); track i; let i = $index) {
        <ul>
          @if(menu.submenu?.length){
          <button class="btn-menu-list" mat-button [matMenuTriggerFor]="submenu" routerLinkActive="router-link-active">
            <mat-icon>
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#7b7b7b">
                <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
              </svg>
            </mat-icon>
            {{ menu.title }}
          </button>
          <mat-menu #submenu="matMenu">
            @for (subMenu of menu.submenu; track i; let i = $index) {

            <!-- subMenu Type-->
            @if(subMenu.submenu?.length){
            <button mat-menu-item [matMenuTriggerFor]="submenuchild" routerLinkActive="router-link-active">
              <p class="font-size-18">
                {{ subMenu.title }}
              </p>
            </button>

            <mat-menu #submenuchild="matMenu">
              @for (subMenuChild of subMenu.submenu; track i; let i = $index) {
              <button mat-menu-item (click)="handleClick(subMenuChild, 1)">
                <p class="font-size-18">
                  {{ subMenuChild.title }}
                </p>
              </button>
              }
            </mat-menu>
            } @else{
            <button mat-menu-item (click)="handleClick(subMenu, 1)">
              <p class="font-size-18">
                {{ subMenu.title }}
              </p>
            </button>
            } }
          </mat-menu>
          } @else {
          <li>
            <button mat-button (click)="handleClick(menu)">
              {{ menu.title }}
            </button>
          </li>
          }
        </ul>
        }
      </nav>
      <!-- NOTE Hamburger Menu -->
      <div class="btn-menu-mini">
        <button mat-icon-button (click)="drawer.toggle()" aria-label="Example icon button with a menu icon">
          <mat-icon class="mat-icon-size" svgIcon="menu-svg"></mat-icon>
        </button>
      </div>
    </header>

    <div class="router-outlet-container">
      <router-outlet></router-outlet>
    </div>

    <div class="themeDisplay1">
      <lib-web-shared-ui-footer
        class="themeFooter7"
        [data]="footerList()"
        [footerlength]="footerlength()"
        (OnClick)="handleClickFooter($event)"
      ></lib-web-shared-ui-footer>
    </div>
    <div class="themeDisplay2">
      <lib-web-shared-ui-footer
        class="themeFooter2"
        [data]="footerList()"
        [footerlength]="footerlength()"
        (OnClick)="handleClickFooter($event)"
      ></lib-web-shared-ui-footer>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
